import React, {useState} from 'react';
import Draggable from 'react-draggable';
import { FaLaptopCode } from "react-icons/fa";
import { GrDrag } from "react-icons/gr";
import { FiMaximize, FiMinimize } from "react-icons/fi";

import UnityPane from '../../containers/unity-pane.jsx';
import styles from './gui.css';
import CmraCurriculum from '../../containers/cmra-curriculum.jsx';
import ToolBar from '../../containers/cmra-toolbar.jsx';
import Blocks from '../../containers/blocks.jsx';

const RobotBlocksGui = props => {
    const [expandView, setExpandView] = useState(false);
    const {
        canUseCloud,
        blocksTabVisible,
        options,
        stageSize,
        vm
    } = props;

    const expandedView = {
        width: '44vw',
        height: '88vh'
    }

    const normalView = {
        width: '33vw',
        height: '66vh'
    }

    return(
        <div className={styles.app_wrapper} >
            <div className={styles.floating_window_bounds}>
                <Draggable
                    axis="both"
                    handle=".handle"
                    defaultPosition={{ x: 600, y: 50 }}
                    position={null}
                    grid={[2, 2]}
                    scale={1}
                    cancel=".unity-container"
                    bounds={'parent'}
                >
                    <div 
                        className={styles.floatingWindow} 
                        style={ expandView ? expandedView : normalView }>
                        <div className={`handle ${styles.handle_menu}`} >
                            <div className={styles.menu_row}>
                                <div className={styles.menu_row_header}>
                                    <span className={styles.menu_row_icon}><FaLaptopCode/></span>
                                    <span className={styles.menu_row_title}>Virtual Robot Simulation</span>
                                </div>
                                { expandView ? 
                                    <a className={styles.menu_row_button}onClick={() => setExpandView(false)}>
                                        <span className={styles.menu_row_button_icon}><FiMinimize/></span>
                                        <span className={styles.menu_row_button_text}>Shrink</span>
                                    </a> :
                                    <a className={styles.menu_row_button} onClick={() => setExpandView(true)}>
                                        <span className={styles.menu_row_button_icon}><FiMaximize/></span>
                                        <span className={styles.menu_row_button_text}>Expand</span>
                                    </a>
                                }
                                
                                <span className={styles.menu_row_icon}><GrDrag/></span>
                            </div>
                            
                            <UnityPane width='100%' height='100%' />
                        </div>
                    </div>

                </Draggable>
                <ToolBar style={styles.project_menu}/>
            </div>
            <div className={styles.split_wrapper} >
            
                <Blocks
                    canUseCloud={canUseCloud}
                    grow={1}
                    isVisible={blocksTabVisible}
                    options={options}
                    stageSize={stageSize}
                    vm={vm}
                />
                <div className={styles.curriculumView} >
                    <CmraCurriculum />
                </div>
            </div>
            <div className={styles.version_number}>Version: 1.0.0</div>
        </div>
    )
};

export default RobotBlocksGui;